/// <amd-module name="TFS/Admin/Common/Controls/RestoreProjectsDialog/RestoreProjectsDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { VssComponent } from "VSS/Platform/Layout";
import * as AdminResources from "TFS/Admin/Common/Controls/Resources";
import { ContentSize } from "VSSUI/Callout";

export interface IRestoreMultiDialogProps {
    restorableProjects: string[];
    unrestorableProjects: string[];
    onCancel: () => void;
    onRestoreProject: () => void;
}

export class RestoreMultiDialog extends React.Component<IRestoreMultiDialogProps, {}> {
    private restorableProjectsList: string;
    private restorableProjectsCount: number;
    private unrestorableProjectsList: string;
    private unrestorableProjectsCount: number;

    constructor(props: IRestoreMultiDialogProps) {
        super(props);
        this.restorableProjectsList = this.props.restorableProjects.join(", ");
        this.restorableProjectsCount = this.props.restorableProjects.length;

        this.unrestorableProjectsList = this.props.unrestorableProjects.join(", ");
        this.unrestorableProjectsCount = this.props.unrestorableProjects.length;
    }

    public render(): JSX.Element {
        return (
            <Dialog
                calloutClassName="restore-multi-project-dialog"
                titleProps={{
                    text:
                        this.restorableProjectsCount > 1 || this.unrestorableProjectsCount > 1
                            ? AdminResources.RestoreMultiProjectDialogTitle
                            : AdminResources.RestoreProjectDialogTitle
                }}
                onDismiss={() => this.props.onCancel()}
                contentSize={ContentSize.Large}
                footerButtonProps={[
                    { text: AdminResources.Cancel, onClick: this.props.onCancel },
                    {
                        className: "restore-project-button",
                        primary: true,
                        onClick: this.props.onRestoreProject,
                        text: AdminResources.RestoreButton,
                        disabled: this.restorableProjectsCount < 1
                    }
                ]}
            >
                <div>
                    <div className="restore-project-first-paragraph">
                        <FormatComponent format={AdminResources.UnableToRestoreProjects} className="project-list">
                            <span className="fontWeightSemiBold">{this.unrestorableProjectsList}</span>
                        </FormatComponent>
                    </div>
                    {this.restorableProjectsCount > 0 && (
                        <div className="restore-project-first-paragraph">
                            <FormatComponent format={AdminResources.AbleToRestoreProjects} className="project-list">
                                <span className="fontWeightSemiBold">{this.restorableProjectsList}</span>
                            </FormatComponent>
                        </div>
                    )}
                </div>
            </Dialog>
        );
    }
}

VssComponent.register("ms.vss-admin-web.restore-multi-dialog", RestoreMultiDialog);
